var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyArrowCircleLeft = function SvgHappyArrowCircleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "happyArrowCircleLeft_svg__a",
    d: "M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12c6.624-.007 11.993-5.376 12-12m-13.707 5.2-4.5-4.5a1 1 0 0 1 0-1.414l4.5-4.5a1.002 1.002 0 0 1 1.687.441c.091.35-.013.722-.273.973l-2.366 2.371a.25.25 0 0 0 .177.429H18a1 1 0 0 1 0 2H9.518a.25.25 0 0 0-.177.426l2.366 2.367a1 1 0 0 1-1.414 1.407"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#happyArrowCircleLeft_svg__a",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
};
export default SvgHappyArrowCircleLeft;